// extracted by mini-css-extract-plugin
export default {"_":"TagsBar____TV7-3","tag":"TagsBar_tag__rtULh","tagLogo":"TagsBar_tagLogo__mA7Ct","tagName":"TagsBar_tagName__BrhU8"};